import React from 'react';
import useReleaseNotes from 'src/hooks/use-release-notes';
import { FaIcon, FaIcons } from '@innovationnorway/component-library';
import { formatDateToNOString } from 'src/utils/FormatValue';
import TertiaryButton from 'src/components/TertiaryButton/TertiaryButton';
import { useTranslation } from 'react-i18next';

const ReleaseNotes = () => {
  const { releaseNotes, likeMutation } = useReleaseNotes();
  const { t: tCommon } = useTranslation('common');

  return (
    <main className="full-width-layout stack">
      <h1>{tCommon('releaseNotes')}</h1>
      {releaseNotes.map((note) => (
        <details className="box" key={note.id}>
          <summary className=" background-color--blue-12">
            <h2 className="margin--0">
              {note.title}{' '}
              {formatDateToNOString(new Date(note.createdOn), false, '{date}.{month}.{year}', true)}{' '}
              <FaIcon name={FaIcons.AngleDown} />
            </h2>
          </summary>
          <div className="stack-medium padding--2">
            <p>{note.body}</p>
            <div className="display--flex gap--10">
              <TertiaryButton
                onClick={() =>
                  likeMutation.mutateAsync({ id: note.id, likes: !note.userHasLikedThisReleaseNote })
                }
                minimalPadding
                faIcon={note.userHasLikedThisReleaseNote ? FaIcons.ThumbsUpSolid : FaIcons.ThumbsUpLight}
                selected={note.userHasLikedThisReleaseNote}
              >
                {tCommon('releaseNotes.useful')}
              </TertiaryButton>
              <p className="margin--0">
                {note.likes} {tCommon('releaseNotes.voted')}
              </p>
            </div>
          </div>
        </details>
      ))}
    </main>
  );
};

export default ReleaseNotes;
